import { div } from '@mui/system'
import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilled, ButtonFilledAutoWidth } from '../../../components/button'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { CreateDepartmentService, UpdateDepartmentService } from '../../../services/DepartmentServices'
import { useNavigate, useLocation } from 'react-router-dom'
import { MobileBackOption } from '../../../components/appbars/mobile/DashboardMobile'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { message, Select } from 'antd'
import { CreateClassRoomService, UpdateClassRoomService } from '../../../services/admin/ClassRoomServices'

function ClassRoomCE() {
 
  const [data,setdata] = useState({name:'',label:''});  
  const [error,seterror] = useState({name:'',label:''}); 
  const [streamlist,setstreamlist] = useState([]);

  const {state} = useLocation();
  const navigate = useNavigate();


  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      setdata({...data,...state})
    }
  },[state])
   
  console.log(streamlist,'data') 

  
  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    if(!data.name){
        seterror({...error,name:'Name field is required *'})
    }else if(!data.label){
        seterror({...error,label:'Label field is required *'})
    }else{

        let send_data = {...data}
       
        if(state?._id === undefined || state?._id === null){
        const response = await CreateClassRoomService(send_data)
        if (response.status === 201) {
          resetform()
          toast.success('Class Room Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,days:response?.data?.errors?.days})
        } 
      }else{
        let send_data = {...data}
       
        const response = await UpdateClassRoomService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Class Room Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,days:response?.data?.errors?.days})
        } 
      }
  }
  }


  function resetform(){
    setdata({name:'',label:''})
    seterror({name:'',label:''})
  }


  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} Class Room</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Class Room</b> for your clients segregate followup.</h6>
     

        <TextInput 
            label={'Name'}  
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder="Enter your name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>


          <TextInput 
            label={'Label'}  
            variant="standard"
            name="label"
            type="text"
            error={error.label}
            value={data.label}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>  

        

        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE CLASS ROOM" : "ADD CLASS ROOM"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default ClassRoomCE